import type { RootState } from '@/lib/store';
import { movementMuscleAdapter } from '@/entities/movement-muscle/model/movement-muscle.slice';

const baseSelectors = movementMuscleAdapter.getSelectors(
	(state: RootState) => state.movementMuscles,
);
const movementMuscleSliceSelectors = {
	...baseSelectors,
};

export { movementMuscleSliceSelectors };
